module.exports = __webpack_public_path__ + "static/media/03-11-01.2af65905.png";